<template lang="pug">
.entity-tab.py-0.fluid
  v-container
    v-row.px-0.d-flex
      v-col.pt-1
        h2.px-4.primary--text {{ $t('Chart.dataSets') }}
      v-col.pt-1.px-0(cols="6")
        g-btn.mr-3.white--text.float-right(
          color="primary",
          @click="instance.push({ __id: $uid(), entityState: 4, _Entity: entity.name })"
        ) {{ $t('Chart.addDataSet') }}

    v-row.px-0
      v-col
        v-form
          v-divider(color="light.primary")
          v-tabs#order-lines-tabs(
            v-model="tab",
            center-active,
            show-arrows,
            light,
            next-icon="mdi-arrow-right-circle-outline",
            prev-icon="mdi-arrow-left-circle-outline"
          )
            template(v-for="(item, i) in displayableItems")
              v-tab(
                v-if="isNotDeleted(item)",
                :key="key + '' + i",
                :path="`${path}[${i}]`"
              ) {{ getTabLabel(item) }}
          v-divider(color="light.primary")
          v-tabs-items(v-model="tab")
            template(v-for="(item, i) in displayableItems")
              v-tab-item(v-if="isNotDeleted(item)", :key="key + '' + i")
                v-row.mt-5
                  v-col.d-flex.justify-end
                    v-icon(@click="setAsDeleted($event, i, item)")  mdi-close
                data-set(
                  :chips="false",
                  :path="`${path}[${i}]`",
                  :parentPath="`${path}`",
                  :entity="$findEntity(relation.type)",
                  fromList,
                  :key="key+ '' + i",
                  :elementIndex="i",
                  v-bind="{ ...$attrs, parent, relation, isActive, modalInstance, errors }",
                )

</template>

<style scoped>
#order-lines-tabs .v-item-group .v-slide-group__prev {
  position: absolute;
  right: 30px;
  top: 12px;
}

#order-lines-tabs .v-tabs-bar .v-slide-group__next {
  min-width: 80px;
  align-content: flex-end;
}

#order-lines-tabs .v-tabs-bar .v-slide-group__next i {
  display: flex;
  align-content: flex-start;
  right: -15px;
}

#order-lines-tabs
  .v-tabs-bar
  .v-slide-group__wrapper
  .v-slide-group__content
  .v-tab {
  text-transform: none;
}

#order-lines-tabs
  .v-tabs-bar
  .v-slide-group__wrapper
  .v-slide-group__content
  .v-tab--active {
  font-weight: 800;
}
</style>

<script>
import EntityMixin from "@/mixins";
import axios from 'axios';

export default {
  mixins: [EntityMixin],
  props: ['disabled', 'entity', 'errors', 'ignoreFields', 'ignoreTabs', 'ignoreTypes', 'isActive', 'modalInstance', 'only', 'parent', 'parentInstance', 'path', 'relation'],
  data: function () {
    return {
      key: 0,
      tab: null,
      tabDisplay: 1,
    };
  },
  computed: {
    displayableItems() {
      return this.instance.length > 0
        ? this.instance.filter((i) => i.entityState != 2)
        : [];
    },
  },
  methods: {
    getTabLabel(item) {
      let index = this.displayableItems.indexOf(item);
      return `${this.$t('DataSets.set')} ${index + 1}`
    },
    setAsDeleted (element, i, instance) {
      if (instance && instance.id)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 })
      else if (!instance && element)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 })
      else {
        this.instance.splice(i, 1)
      }
      this.key++;
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
  },
  async created() {
    try {
      this.loading = true;
      var entity = {}
      if (this.parentInstance && this.parentInstance.id && (this.path !== this.entity.name) && _.isEmpty(this.instance)){
          entity = (await axios.get(this.parent.name + '/' + this.parentInstance.id,  {
             params: {
              Load: [...this.$relationLoads(this.parent, this.entity)]
            }
          })).data
          this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: entity[this.relation.name]  })
      }
      if (!this.instance && this.path !== this.entity.name)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: this.relation.multiple ? [] : entity[this.relation.name] })
    } catch (e) {
      console.log(this.$cleanString(e));
    } finally {
      this.loading = false;
    }
  },
};
</script>
